import { createResource, type RouteResource } from 'react-resource-router';

import { groupCustomizationFeatureStateResource } from '@atlassian/aiops-group-common/resources';
import { assert, AssertionError } from '@atlassian/eoc-common';

import type { SidebarRightsResponse, Team } from '../../common/types';
import { getSidebarRightsEndpoint, getTeamByIdEndpoint } from '../endpoints';

export const teamResource: RouteResource<Team> = createResource({
	type: 'teamResource',
	getKey: (routerContext) => {
		const teamId = routerContext.match.params?.teamId;

		return `team-dashboard/${teamId ?? ''}`;
	},
	getData: async (routerContext) => {
		const teamId = routerContext.match.params?.teamId;

		assert(
			!!teamId,
			new AssertionError('teamSidebarResource', 'teamId should be set to fetch team-dashboard'),
		);

		return getTeamByIdEndpoint(teamId).catch((e) => {
			e.skipSentry = true;
			throw e;
		});
	},
	maxAge: 300000, // refresh it after 5 minutes
	isBrowserOnly: true,
});

export const sidebarRightsResource: RouteResource<SidebarRightsResponse> = createResource({
	type: 'sidebarRightsResource',
	getKey: (routerContext) => {
		const teamId = routerContext.match.params?.teamId;
		return `team-dashboard/${teamId ?? ''}/sidebar-rights`;
	},
	getData: async (routerContext) => {
		const teamId = routerContext.match.params?.teamId;

		assert(
			!!teamId,
			new AssertionError('teamSidebarResource', 'teamId should be set to fetch sidebar rights'),
		);

		return getSidebarRightsEndpoint(teamId).catch((e) => {
			e.skipSentry = true;
			throw e;
		});
	},
	isBrowserOnly: true,
	maxAge: Infinity,
});

export const resources = (): (
	| RouteResource<Team>
	| RouteResource<SidebarRightsResponse>
	| RouteResource<{
			isEnabled: boolean;
	  }>
)[] => [teamResource, sidebarRightsResource, groupCustomizationFeatureStateResource];

export type { Team } from '../../common/types';
